module.exports = __webpack_public_path__ + "img/1283.651b55a5.gif";